import { _paleta, paleta } from '@constants/Color'
import Vue from 'vue'
import store from '@state/store'

export const SET_PALETTE = (state, payload) => {
  // const { primary } = payload

  // const generated = generatePalette(primary).map((item) => item.toLowerCase())

  // const palette = []
  //
  // if (generated.includes(primary.toLowerCase())) {
  //   palette.push(
  //     ...generated.splice(generated.indexOf(primary.toLowerCase()), 1)
  //   )
  // }
  //
  // while (generated.length) {
  //   if (generated.length % 2 === 0) {
  //     palette.push(generated.shift())
  //   } else {
  //     palette.push(generated.pop())
  //   }
  // }

  state.colors.paleta = [..._paleta.filter((color) => !!color), ...paleta]
}

const SET_CLASS_COLORS = (state, payload) => {
  payload.forEach((v) => {
    if (!state.classColors[v]) {
      state.classColors[v] =
        paleta[Object.keys(state.classColors).length % paleta.length]
    }
  })
}

const SET_BANKS_COLORS = (state, payload) => {
  let aux = {}
  payload.forEach((v, i) => {
    aux[v] = paleta.reverse()[i % paleta.length]
  })
  state.banksColors = aux
}

const UPDATE_COLOR_MODE = (state, payload) => {
  if (payload.mode && payload.colors) {
    state.colors[payload.mode] = {
      ...state.colors[payload.mode],
      ...payload.colors,
    }

    Object.entries(state.colors[payload.mode]).forEach((c) => {
      document.documentElement.style.setProperty(`--${c[0]}`, c[1])
    })
  }
}

const SET_ESCRITORIO_BASE = (state, payload) => {
  if (payload && payload.id_escritorio) {
    state.escritorio = payload
  }
}

const SET_COLORS = (state, { colors, vuetify }) => {
  const payload = colors
  if (payload) {
    state.colors['light_mode'] = {
      ...state.colors['light_mode'],
      ...payload,
    }

    const vuetifyInstance = Vue.$vuetify || vuetify
    if (vuetifyInstance) {
      const theme = vuetifyInstance.framework.theme
      Object.assign(theme.themes.light, payload)
      Object.assign(theme.themes.dark, payload)
    } else {
      // Fallback para variáveis CSS se o Vuetify não estiver disponível
      Object.entries(payload).forEach(([key, value]) => {
        document.documentElement.style.setProperty(`--v-${key}-base`, value)
      })
    }
    if (Vue.$vuetify || vuetify) {
      Object.entries(payload).forEach((c) => {
        ;(Vue.$vuetify || vuetify.framework).theme.themes.light[c[0]] = c[1]
      })
    } else {
      document.documentElement.style.setProperty(
        '--v-primary-base',
        payload.primary
      )
      document.documentElement.style.setProperty(
        '--v-accent-base',
        payload.accent
      )
    }
  }
}

const LOAD_CONFIG_LOCAL = (state) => {
  const user = store.getters['user/currentUser'] || {}
  const config = window.localStorage.getItem(`6CFgc${user.id_interno}10239c`)
  if (config) {
    state.config_local = {
      ...state.config_local,
      ...JSON.parse(config),
    }
  }
}

const SET_CONFIG_LOCAL = (state, payload) => {
  const user = store.getters['user/currentUser'] || {}
  if (payload) {
    state.config_local = {
      ...state.config_local,
      ...payload,
    }

    window.localStorage.setItem(
      `6CFgc${user.id_interno}10239c`,
      JSON.stringify(state.config_local)
    )
  }
}

const SET_LOGO = (state, payload) => {
  if (payload) {
    state.logo = payload
  }
}

export const SET_LOGO_BRANCA = (state, payload) => {
  if (payload) {
    state.logoBranca = payload
  }
}

const SET_FAVICON = (state, payload) => {
  if (payload) {
    state.favicon = payload
  }
}

export const SET_FAVICON_BRANCA = (state, payload) => {
  if (payload) {
    state.faviconBranca = payload
  }
}

const SET_BG = (state, payload) => {
  if (payload) {
    state.backgroundImage = payload
  }
}

// `Vue.set`, e não atribuição direta: `state.show` nasce com ~23 chaves
// pré-declaradas em state.js, mas as funcionalidades do escritório chegam do
// `/api/config` com nomes que NÃO estão lá ('Financial Planning',
// 'open-finance-pj', ...). Em Vue 2, chave nova atribuída por `obj[k] = v` não
// é reativa — o computed que lê `$access[flag]` avalia certo na montagem, mas
// não redesenha se a flag mudar em runtime (revogação, refresh de permissões).
// Medido em 10/09/2026 na aba Open Finance de Configurações > FP.
const SET_MODULE = (state, payload) => {
  if (payload.module) {
    Vue.set(state.show, payload.module, payload.value)
  }
}

export {
  SET_CLASS_COLORS,
  SET_BANKS_COLORS,
  UPDATE_COLOR_MODE,
  SET_ESCRITORIO_BASE,
  SET_COLORS,
  LOAD_CONFIG_LOCAL,
  SET_CONFIG_LOCAL,
  SET_LOGO,
  SET_FAVICON,
  SET_BG,
  SET_MODULE,
}
